<div id="div_block-124-1139" class="ct-div-block archive-post">
    <div id="div_block-2-1993" class="ct-div-block ">
        <div id="code_block-25-1993" class="ct-code-block"><svg>
                <clipPath id="general-banner-desktop" clipPathUnits="objectBoundingBox">
                    <path
                        d="M0,1 H0.815 C0.83,1,0.843,0.997,0.851,0.96 L0.994,0.231 C1,0.15,0.991,0.047,0.959,0.047 L0,0.02 V1">
                    </path>
                </clipPath>
                <clipPath id="general-banner-mobile" clipPathUnits="objectBoundingBox">
                    <path d="M0,1 H0.976 C0.989,1,1,0.981,1,0.953 V0.055 C1,0.025,0.988,0.002,0.974,0.004 L0,0.156 V1">
                    </path>
                </clipPath>
            </svg></div>
        <div id="div_block-3-1993" class="ct-div-block general-banner"></div>
        <div id="code_block-16-1997" class="ct-code-block banner-image">
          <img width="100%" height="100%" [src]="image" style="object-fit: cover;">
        </div>

        <div id="new_columns-13-1993" class="ct-new-columns">
            <div id="div_block-14-1993" class="ct-div-block">
                <div id="div_block-33-1993" class="ct-div-block">
                    <div id="div_block-34-1993" class="ct-div-block"></div>
                    <h1 id="headline-14-1997" class="ct-headline hero-heading main-banner__heading">{{ title }}<div></div>
                    </h1>
                </div>
            </div>
            <div id="div_block-24-1993" class="ct-div-block"></div>
        </div>
    </div>
</div>